<div class="w-100 mb-15 mct-flex mct-row mct-justify-between mct-items-center">
  <h4>{{ 'revenue.pledge-campaigns.title' | translate | titlecase }}</h4>
  <div>
    <button
      pButton
      type="button"
      *wlAccessControl="securityElementNames.fullAccess(securityElementNames.Manage_Revenue_Codes)"
      class="mct-flex atlas-btn atlas-btn-primary add-button mb-5 mct-justify-center mct-items-center"
      type="button"
      (click)="openPledgeCampaignsAddDialog()"
    >
      <i class="large-icon pi pi-plus"></i>
      {{ 'revenue.pledge-campaigns.pledge-campaign.add-header' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="pledgeInvoiceReports()">
      {{ 'revenue.pledge-campaigns.actions.pledges-by-date' | translate | titlecase }}
    </button>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    [lazy]="true"
    (onLazyLoad)="lazyLoad($event)"
    [filterDelay]="500"
    [loading]="loading"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="CampaignName">
          {{ 'revenue.pledge-campaigns.campaign-name' | translate | titlecase }}
          <p-sortIcon field="CampaignName"></p-sortIcon>
        </th>
        <th pSortableColumn="CampaignYear">
          {{ 'revenue.pledge-campaigns.campaign-year' | translate | titlecase }}
          <p-sortIcon field="CampaignYear"></p-sortIcon>
        </th>
        <th pSortableColumn="Goal">
          {{ 'revenue.pledge-campaigns.campaign-goal' | translate | titlecase }}
          <p-sortIcon field="Goal"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            placeholder="{{ 'revenue.pledge-campaigns.filter-campaign-name' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.CampaignName"
            (input)="filterChanged()"
          />
        </th>
        <th>
          <p-inputNumber
            placeholder="{{ 'revenue.pledge-campaigns.filter-campaign-year' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.CampaignYear"
            (onInput)="filterChanged()"
            (onClear)="filterChanged()"
            showClear="true"
          ></p-inputNumber>
        </th>
        <th>
          <div class="p-inputgroup">
            <span class="atlas-input-addon">$</span>
            <p-inputNumber
              placeholder="{{ 'revenue.pledge-campaigns.filter-campaign-goal' | translate | titlecase }}"
              styleClass="p-column-filter"
              [(ngModel)]="searchParams.Goal"
              (onInput)="filterChanged()"
              (onClear)="filterChanged()"
              showClear="true"
              mode="decimal"
            ></p-inputNumber>
          </div>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-campaign>
      <tr>
        <td>{{ campaign.CampaignName }}</td>
        <td>{{ campaign.CampaignYear }}</td>
        <td>{{ campaign.Goal | currency: 'USD' : 'symbol' : '1.0-0' }}</td>
        <td class="action-column">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForPledgeCampaign(campaign)">
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <wl-page-size-dropdown
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
</div>

<wl-pledge-campaigns-add-dialog (pledgeCampaignSaved)="search()"></wl-pledge-campaigns-add-dialog>

<p-confirmDialog
  #cd
  key="deletePledgeCampaignCD"
  header="{{ 'revenue.pledge-campaigns.confirm-delete' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
